export function postRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_POST_START":           
        case "FETCH_POSTS_START":                                 
        case "UPDATE_POST_START":                                 
        case "DELETE_POST_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_POST_FULFILLED":           
        case "FETCH_POSTS_FULFILLED":                                 
        case "UPDATE_POST_FULFILLED":                                 
        case "DELETE_POST_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_POST_ERROR":
        case "FETCH_POSTS_ERROR":
        case "UPDATE_POST_ERROR":
        case "DELETE_POST_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}